module.exports = __webpack_public_path__ + "img/windows_and_doors.506869af.jpg";